import { blurActiveElement } from '@/utils';
import { CONVERSION_MODE } from '@/constants';
import { useConversionPreview } from '@/hooks';

const { skip, sync } = CONVERSION_MODE;

const options = [
  { value: skip, label: 'SKIP converted' },
  { value: sync, label: 'SYNC converted' },
];

const ConversionModeSelect = ({
  value,
  total,
  disabled,
  onChange,
  sourceIds,
  isComplete,
  wouldSkipAll,
  priorConversions,
}) => {
  const preview = useConversionPreview({
    total,
    sourceIds,
    isComplete,
    mode: value,
    wouldSkipAll,
    priorConversions,
  });

  const handleChange = (e) => {
    onChange(e.target.value);
    blurActiveElement();
  };

  return (
    <div>
      <div className="input-group">
        <select
          value={value}
          disabled={disabled}
          onChange={handleChange}
          className="form-select"
        >
          {options.map(({ label, value: optionValue }) => (
            <option key={optionValue} value={optionValue}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {preview && (
        <div className="form-text mt-2 d-flex align-items-center">
          <i
            aria-hidden="true"
            className="fas fa-info-circle text-info me-2"
          ></i>
          <span>{preview}</span>
        </div>
      )}
    </div>
  );
};

export default ConversionModeSelect;
